import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const dataVendorExtractApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDataVendorExtract: builder.query({
      query: ([dataVendorId, extractKey]) => `/data_vendors/${dataVendorId}/extracts/${extractKey}`,
      providesTags: (result, error, arg) => [{ type: 'DataVendorExtract', id: arg[1] }],
    }),
    createDataVendorExtract: builder.mutation({
      query: (extract) => ({
        url: `/data_vendors/${extract.dataVendorId}/extracts/`,
        method: 'POST',
        body: extract
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'DataVendor', id: arg.dataVendorId },
        { type: 'DataVendorExtract', id: 'LIST' }],
    }),
    updateDataVendorExtract: builder.mutation({
      query: (extract) => ({
        url: `/data_vendors/${extract.dataVendorId}/extracts/${extract.key}`,
        method: 'PUT',
        body: extract,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'DataVendor', id: arg.dataVendorId  },
        { type: 'DataVendorExtract', id: arg.key }
      ]
    }),
    runDataVendorExtract: builder.mutation({
      query: ([dataVendorId, extractKey]) => ({
        url: `/data_vendors/${dataVendorId}/extracts/${extractKey}/run`,
        method: 'POST'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.run")})
    }),
    deleteDataVendorExtract: builder.mutation({
      query: ([dataVendorId, extractId]) => ({
        url: `/data_vendors/${dataVendorId}/extracts/${extractId}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => {
      return [
        { type: 'DataVendor', id: arg.dataVendorId  },
        { type: 'DataVendorExtract', id: arg.extractId }
      ]}
    }),
    getDataVendorExtractAggregationOptions: builder.query({
      query: (dataVendorId) => ({
        url: `/data_vendors/${dataVendorId}/extracts/aggregation_options`
      }),
      providesTags: [{ type: 'AggregationOptions' }],

    })
  }),
  overrideExisting: false
})

export const {
  useGetDataVendorExtractQuery,
  useGetDataVendorExtractAggregationOptionsQuery,
  useCreateDataVendorExtractMutation,
  useUpdateDataVendorExtractMutation,
  useDeleteDataVendorExtractMutation,
  useRunDataVendorExtractMutation
} = dataVendorExtractApiSlice
